import React, {useState, useEffect, useContext, useMemo} from 'react';
import {getDiagnosticSkillSummary} from "../axiosRequests/axiosRequests";
import {BrandContext} from "@context/BrandContext";
import TableAntD from "@common/TableAntD";
import {Form, Progress, Select} from "antd";
import {ContentTabs} from "../TestEdit";
import MathJaxHTMLContent from "@common/MathJaxHTMLContent";
import Button from "@common/Button";
import CircleProgressWithFraction from "@common/CircleProgressWithFraction";
import {Cancel, CheckCircle} from "@mui/icons-material";

export const TestSkillSummary = ({ testId, searchAndAdd }) => {

    const [activeTab, setActiveTab] = useState('0'),
        [skillSummaryBeans, setSkillSummaryBeans] = useState([]),
        brandConfig = useContext(BrandContext),
        [dataLoading, setDataLoading] = useState(true);

    useEffect(()=>{
        if(testId){
            getDiagnosticSkillSummary(testId).then((data)=>{
                setSkillSummaryBeans(data);
            }).finally(()=>{
                setDataLoading(false);
            });
        }
    },[testId]);

    const handleSearchAndAdd = (val)=>{
        searchAndAdd(val);
    }

    const ListSkill = ({name, curriculum, ...rest })=>{
        return (
            <li className={'flexRow flexAlignCentre smallGap'}>
                {name}
                {rest.used && <i className="check-icon-green flex"><CheckCircle/></i>}
                {!rest.used && <i className="cross-icon-red flex"><Cancel/></i>}
                {!rest.used && <Button style={{minHeight:'26px'}} onClick={()=>{handleSearchAndAdd({curriculum, ...rest})}}>Search by skill</Button>}
            </li>
        );
    };

    const skillSummaryColumns = useMemo(()=>{
        return [
            {
                title: brandConfig.conceptName,
                dataIndex: 'topicName',
                render:(val)=>{
                    return <MathJaxHTMLContent html={val} showLoader={false}/>
                }
            },
            {
                title: 'Skill coverage',
                dataIndex: 'skillsCoverage',
                onCell: (record, rowIndex) => {
                    return {style: {textAlign: 'center'}};
                },
                render:(skillsCoverage, row)=>{
                    return (<div>
                        <CircleProgressWithFraction
                            numer={skillsCoverage}
                            denom={row.skills.length}
                        />
                    </div>)
                }
            },
            {
                title: 'Skill',
                dataIndex: 'skills',
                render:(skills, row)=>{
                    return (<ul className={'flexColumn smallGap'}>
                        {skills.map((skill,idx) => {
                            return <ListSkill
                                // key={idx+skill.skillId}
                                curriculum={row.curriculum} {...skill} />;
                        })}
                    </ul>)
                }
            }]
    },[]);

    const onSelectChange = (val)=>{
        setActiveTab(val);
    }

    return (
        <section id="testSkillSummaryWrapper" className={'flexColumn mediumGap'} aria-labelledby="skill-summary-heading">
            <header>
                <h4 id="skill-summary-heading">In this test you have selected question(s) from the following skills:</h4>
                <Form.Item label={'View skills by:'}>
                    <Select
                        value={activeTab}
                        onChange={onSelectChange}
                        options={[
                            {label: ContentTabs.Text.display, value: ContentTabs.Text.val},
                            {label: ContentTabs.Curriculum.display, value: ContentTabs.Curriculum.val}
                        ]}
                        style={{minWidth: 200, width:'fit-content'}}
                    />
                </Form.Item>
            </header>
            <div id="testSkillSummaryText" style={{ display: activeTab === ContentTabs.Text.val ? 'block' : 'none' }}>
                <TableAntD
                    id="testSkillSummaryTextTable"
                    data={skillSummaryBeans.filter(item=>!item.curriculum)}
                    // onSearchAndAdd={handleSearchAndAddClick}
                    loading={dataLoading}
                    noDataMessage={'No skills are included in this '+brandConfig.testName}
                    columnData={skillSummaryColumns}
                />
            </div>
            <div id="testSkillSummaryCurriculum" style={{ display: activeTab === ContentTabs.Curriculum.val ? 'block' : 'none' }}>
                <TableAntD
                    id="testSkillSummaryCurriculumTable"
                    data={skillSummaryBeans.filter(item => item.curriculum)}
                    columnData={skillSummaryColumns}
                    loading={dataLoading}
                    noDataMessage={'No skills are included in this '+brandConfig.testName}
                    // onSearchAndAdd={handleSearchAndAddClick}
                />
            </div>
        </section>
    );
};